import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import defultuser from "../../assets/images/defult-user.png";
import img from "../../assets/images/Raseel_Horizontal.jpg";
import MessagePopup from "./MessagePopup";
import { app } from "../../config/app";
import Profile from "../profile/index";
import ImageHandler from "../../components/ImageHandler";
import { ls } from "../../utility/LocalStorage";

/**
 * Header Componenet - Used to display informations about logged user utility type, notification & profile details.
 */
class Header extends Component {
  constructor(props) {
    super(props);
    this._ismounted = false;
  }
  /* componentWillMount() is invoked immediately after a component is mounted.
   * Initialization that requires DOM nodes should go here.
   * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
   */
  toggleSidebar() {
    if ($(window).width() <= 1100) {
      $("body").addClass("menu-closed");
    } else {
      $("body").removeClass("menu-closed");
    }
  }

  componentWillMount() {
    $(document).on("click", function(e) {
      if ($(e.target).closest(".dropdown-togglebbt").length === 0) {
        $(".select-variable ul").hide();
      }
    });
  }
  /* componentDidMount() is invoked immediately after a component is mounted.
   * Initialization that requires DOM nodes should go here.
   * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
   */
  componentDidMount() {
    this._ismounted = true;
    $(window).on("resize", function() {
      if ($(window).width() <= 1100) {
        $("body").addClass("menu-closed");
        $(".container").addClass("full-widthcontainer");
      } else {
        $("body").removeClass("menu-closed");
        $(".container").removeClass("full-widthcontainer");
      }
    });

    if ($(window).width() <= 1100) {
      $("body").addClass("menu-closed");
    }

    $(".dropdown-togglebbt").click(function() {
      $(".select-variable ul").toggle();
    });

    $(".menu-toggle").click(function() {
      $("body").toggleClass("menu-closed");
      if ($("body").hasClass("menu-closed")) {
        $(".menu-closed .rightsidebar-menu .treeview-menu").css(
          "display",
          "none"
        );
      } else {
        $(".rightsidebar-menu .active .treeview-menu").css("display", "block");
      }
    });
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  /**
   * return the user logo
   * If logo does not existed, then return default logo
   */
  getUserLogo() {
    return !_.isEmpty(this.props.auth.getLogo())
      ? this.props.auth.getLogo()
      : defultuser;
  }

  /*
   * State allows React components to change their output over time in response to user actions,
   *network responses, and anything else, without violating this rule
   * React elements are plain objects
   * React DOM compares the element and its children to the previous one,
   * and only applies the DOM updates necessary to bring the DOM to the desired state
   * To render a React element into a root DOM node
   * node whose contents has changed gets updated by React DOM
   */
  render() {
    let name = "";
    let roleName = "";
    let authorizedUserDetails = JSON.parse(ls.getItem("authorizedUserDetails"));
    if (this.props.isLoggedIn()) {
      const authUser = this.props.auth.getAuthUser();
      name = authUser.userName;
      roleName =
        _.isObject(authUser.roleMaster) && !_.isEmpty(authUser.roleMaster)
          ? authUser.roleMaster.roleName
          : "";
    }
    const currentLanguage = localStorage.getItem('language');
    return (
      <React.Fragment>
        <header>
          <div className="header-left">
            <a href="javascript:void(0)" className="menu-toggle" />
            <h1>
              <a href={this.props.auth.getUserLandingPath()} className="logo" style={ localStorage.getItem('country')=="sa"  ?{height:"66px",width:"190px"}:{}} >
                {this.props.auth.getLogo() && (
                  <ImageHandler
                    imageUrl={this.props.auth.getLogo()}
                    type="logo"
                  />
                )}
                 {!this.props.auth.getLogo() && localStorage.getItem('country')!="sa"  ?
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-6674 2347 255.646 14.909"
                  >
                    <path
                      className="a"
                      d="M251.762,6.238c-2.006-.749-2.912-1.248-2.912-2.37,0-.811.777-1.747,2.524-1.747a7.393,7.393,0,0,1,3.042.686l.647-2.121A8.549,8.549,0,0,0,251.438,0c-3.3,0-5.372,1.809-5.372,4.117,0,2.059,1.618,3.306,4.077,4.179,1.942.686,2.718,1.31,2.718,2.37,0,1.185-.971,1.934-2.783,1.934a7.974,7.974,0,0,1-3.689-.936l-.582,2.183a9.06,9.06,0,0,0,4.077.936c3.883,0,5.76-2.059,5.76-4.3,0-2.059-1.23-3.306-3.883-4.242M240.76.25V5.24a58.483,58.483,0,0,0,.259,5.988h-.065a34.877,34.877,0,0,0-2.589-4.8L234.482.25H231.31V14.6h2.524V9.482c0-2.37,0-4.242-.129-6.113h.065A41.146,41.146,0,0,0,236.488,8.3l3.948,6.363h2.848V.312H240.76Zm-18.9,12.476c-2.654,0-4.207-2.37-4.207-5.24,0-2.994,1.424-5.427,4.207-5.427s4.207,2.558,4.207,5.3c-.065,2.994-1.553,5.365-4.207,5.365M221.926,0c-4.272,0-7.184,3.119-7.184,7.548,0,4.242,2.718,7.3,6.99,7.3,4.207,0,7.249-2.745,7.249-7.548-.065-4.117-2.654-7.3-7.055-7.3M209.564,14.6h2.783V.25h-2.783ZM196.361.25V2.433H200.7V14.6h2.783V2.433h4.336V.25Zm-7.572,8.3,1.165-3.556c.259-.873.518-1.871.712-2.682h.065a24.3,24.3,0,0,0,.777,2.682l1.165,3.556Zm3.819-8.3h-3.495L184.259,14.6h2.848l1.294-4.055h4.789l1.359,4.055h2.977ZM179.34,12.663c-3.3,0-5.307-2.059-5.307-5.178a4.923,4.923,0,0,1,5.307-5.3,7.585,7.585,0,0,1,2.977.561L182.9.686a9.87,9.87,0,0,0-3.689-.624c-4.66,0-8.09,2.869-8.09,7.61,0,4.367,2.912,7.236,7.7,7.236a9.831,9.831,0,0,0,3.883-.686l-.453-2.059a8.366,8.366,0,0,1-2.912.5M166.072,14.6h2.783V.25h-2.783ZM160.312.25V5.24a58.469,58.469,0,0,0,.259,5.988h-.065a34.87,34.87,0,0,0-2.589-4.8L154.034.25h-3.171V14.6h2.524V9.482c0-2.37,0-4.242-.129-6.113h.065A41.157,41.157,0,0,0,156.041,8.3l3.948,6.363h2.848V.312h-2.524Zm-15.4,0V8.608c0,2.807-1.165,4.117-3.171,4.117-1.877,0-3.107-1.31-3.107-4.117V.25h-2.718V8.484c0,4.554,2.265,6.363,5.76,6.363,3.624,0,6.019-1.934,6.019-6.425V.25Zm-12.685,0H128.6l-2.071,5.739c-.582,1.684-1.1,3.431-1.489,4.99h-.065c-.388-1.622-.841-3.306-1.424-4.99l-2.006-5.8H117.92l-1.036,14.347h2.589l.324-5.8c.129-1.934.194-4.242.259-6.113h.065c.388,1.809.971,3.805,1.553,5.614l2.006,6.113h2.136l2.2-6.238c.647-1.809,1.294-3.743,1.812-5.552h.065c0,1.934.065,4.179.194,6.051l.259,5.864h2.718Zm-18.575,0h-3.624l-2.071,5.739c-.582,1.684-1.1,3.431-1.489,4.99H106.4c-.388-1.622-.841-3.306-1.424-4.99L102.97.187H99.346L98.31,14.535H100.9l.324-5.8c.129-1.934.194-4.242.259-6.113h.065c.388,1.809.971,3.805,1.553,5.614l2.006,6.113h2.136l2.2-6.238c.647-1.809,1.294-3.743,1.812-5.552h.065c0,1.934.065,4.179.194,6.051l.324,5.864h2.718Zm-24.4,12.476c-2.654,0-4.207-2.37-4.207-5.24,0-2.994,1.489-5.427,4.207-5.427,2.783,0,4.207,2.558,4.207,5.3,0,2.994-1.489,5.365-4.207,5.365M89.379,0c-4.272,0-7.184,3.119-7.184,7.548,0,4.242,2.718,7.3,6.99,7.3,4.207,0,7.249-2.745,7.249-7.548C96.369,3.181,93.78,0,89.379,0M77.729,12.663c-3.3,0-5.307-2.059-5.307-5.178a4.924,4.924,0,0,1,5.307-5.3,7.585,7.585,0,0,1,2.977.561L81.289.686A9.869,9.869,0,0,0,77.6.062c-4.66,0-8.09,2.869-8.09,7.61,0,4.367,2.912,7.236,7.7,7.236a9.831,9.831,0,0,0,3.883-.686l-.453-2.059a8.993,8.993,0,0,1-2.912.5M54.43.125H48.152l-5.566,14.41h5.7L51.388,5.8l2.977,8.733h5.954Zm-25.111,0V4.367h4.336V14.535h6.213V4.367H44.01V.125Zm-4.142,0H18.834l-5.566,14.41h5.7L22,5.8l3.042,8.733h6.019ZM0,.125V4.367H4.336V14.535h6.213V4.367h4.207V.125Z"
                      transform="translate(-6674 2347)"
                    />
                  </svg>
                :<img src={img}/>} 
               
              </a>
            </h1>
          </div>
          <div className="header-right">
            <div
              className="user-profile"
              onClick={() =>
                this.profileInst.toggleModal()
              }
            >
              <div className="profile-link">
                <div className="image-profile">
                  <div className="image">
                    <div className="image-border">
                      <ImageHandler
                        imageUrl={
                          authorizedUserDetails.profilePicture &&
                          authorizedUserDetails.profilePicture
                        }
                        type="profilePicture"
                      />
                      {/* <img src={this.props.auth.authUser.profilePicture ?  "/deviceservice/images/"+this.props.auth.authUser.profilePicture : defultuser} alt="user"/> */}
                    </div>
                  </div>

                  <div className="profile-info">
                    <span className="name">{name}</span>
                    <span className="user-type">{roleName}</span>
                  </div>
                </div>
                <span className="dropdown-icon" />
              </div>

              {/*<div className="user-dropdown">
                            <ul>
                                <li>
                                    <NavLink to="/change/password">{this.props.locale.user.change_password}</NavLink>
                                </li>
                                <li>
                                    <a href="javascript:;" onClick={this.handleLogout}>{this.props.locale.header.logout}</a>
                                </li>
                            </ul>
                        </div>*/}
            </div>
          </div>
          <MessagePopup
            id="access-denied-popup"
            message={this.props.locale.common.no_permission}
          />
        </header>
        <Profile
          {...this.props}
          ref={instance => {
            this.profileInst = instance;
          }}
        />
      </React.Fragment>
    );
  }
}

export default connect()(Header);
